"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_RECEIPT_TYPES = void 0;
const mime_type_1 = require("../commons/mime-type");
exports.SUPPORTED_RECEIPT_TYPES = [...mime_type_1.IMAGES, mime_type_1.PDF];
//# sourceMappingURL=receipt.js.map